module.exports = __webpack_public_path__ + "static/img/wgt-nearly-store.51cad1ef.png";